import { useState } from "react";
import { Form, Link, useRouteLoaderData } from "react-router-dom";

import { AsyncFormSelect } from "../forms/records/form/AsyncFormSelect";
import { SelectOption } from "../forms/types";
import { useAuthStore, User } from "../main/authStore";

import { RentalRecord } from "./types";

type ReturnState = {
    id: string;
    returnedBy: SelectOption | null;
    rentalReturnDate: string;
    returnNotes: string;
    rentalStartDate: string;
};

export default function ReturnForm() {
    const currentUser = useAuthStore(state => state.user) as User;
    const { rental } = useRouteLoaderData("Rental") as { rental: RentalRecord };
    const action = rental.status === "returned" ? "Edit Return" : "Return";
    const [returnData, setReturnData] = useState<ReturnState>({
        id: String(rental.id ?? ""),
        returnedBy: rental.returnedBy ?? {
            value: currentUser.id,
            label: currentUser.userName,
        },
        rentalReturnDate: rental.rentalReturnDate || rental.rentalExpireDate || rental.rentalStartDate,
        returnNotes: rental.returnNotes,
        rentalStartDate: rental.rentalStartDate,
    });

    return (
        <Form method = "post" className = "my-3">
            <input type = "hidden" name = "id" value = {returnData.id} />
            <input type = "hidden" name = "action" value = {action} />
            <div className = "blk5 mb-2 d-flex align-items-center">
                <label className = "fw-bold me-3 required-field" htmlFor = "returnedById">Returned By</label>
                <div style = {{ minWidth: 240, flexGrow: 1 }}>
                    <AsyncFormSelect
                        placeholder = "Search user..."
                        required = {true}
                        name = "returnedById"
                        inputId = "returnedById"
                        fileName = "common/searchUser.php"
                        value = {returnData.returnedBy}
                        onChange = {next => setReturnData({ ...returnData, returnedBy: next as SelectOption })}
                    />
                </div>
            </div>
            <div className = "blk5 mb-2 d-flex align-items-center">
                <label className = "fw-bold me-3 required-field" htmlFor = "rentalReturnDate">Return Date</label>
                <input
                    required
                    type = "date"
                    id = "rentalReturnDate"
                    name = "rentalReturnDate"
                    min = {returnData.rentalStartDate || "1900-01-01"}
                    className = "form-control"
                    value = {returnData.rentalReturnDate}
                    onChange = {e => setReturnData({ ...returnData, rentalReturnDate: e.currentTarget.value })}
                />
            </div>
            <label className = "mb-2 fw-bold" htmlFor = "returnNotes">Return Notes</label>
            <textarea
                id = "returnNotes"
                name = "returnNotes"
                className = "form-control mb-2"
                value = {returnData.returnNotes}
                onChange = {e => setReturnData({ ...returnData, returnNotes: e.currentTarget.value })}
                style = {{ width: "100%" }}
            />
            <div>
                <button className = "btn btn-primary me-3">{action}</button>
                <Link to = ".." className = "btn btn-outline-secondary float-end">Back</Link>
            </div>
        </Form>
    );
}
